import { apiClient } from './client'

export interface ReportDTO {
  id: number
  title: string
  title_en: string | null
  platform: string
  platform_en: string | null
  state: string
  severity: string
  finding_ids: number[]
  body_md: string | null
  output_language: string
  notes: string | null
  updated_at: string
}

export interface ReportCreate {
  title: string
  title_en?: string
  platform: string
  platform_en?: string
  state?: string
  severity: string
  finding_ids?: number[]
  body_md?: string
  output_language?: string
}

export interface ReportExportDTO {
  id: number
  report_id: number | null
  filename: string
  fmt: string
  size_bytes: number
  summary: string | null
  created_at: string
}

export const reportsApi = {
  list: (params?: { state?: string; platform?: string }) =>
    apiClient.get<ReportDTO[]>('/reports', { params }).then((r) => r.data),
  get: (id: number) => apiClient.get<ReportDTO>(`/reports/${id}`).then((r) => r.data),
  create: (body: ReportCreate) => apiClient.post<ReportDTO>('/reports', body).then((r) => r.data),
  update: (id: number, body: Partial<ReportCreate>) =>
    apiClient.patch<ReportDTO>(`/reports/${id}`, body).then((r) => r.data),
  remove: (id: number) => apiClient.delete(`/reports/${id}`).then(() => undefined),
  exportHistory: () =>
    apiClient.get<ReportExportDTO[]>('/reports/exports/history').then((r) => r.data),
}
